export default "__VITE_ASSET__ByvvkoYO__"